import "./GeneralSettingsForm.scss";

export const GeneralSettingsForm = ({ children }) => {
  return <div className="col-12 col-md-6 general-settings-form-wrapper">{children}</div>;
};
